import { CtrlType, CtrlProps } from "@yuigoto/ctrl";

/**
 * @type {CtrlProps[]}
 */
export const PasswordControl = [
  {
    name: "oldPassword",
    label: "Senha atual",
    description: "Obs.: insira a sua senha usada atualmente.",
    placeholder: "••••••",
    type: CtrlType.PASSWORD,
    required: true,
    requiredMessage: "Campo obrigatório"
  },
  {
    name: "newPassword",
    label: "Nova senha",
    description: "Obs.: sua senha deve ter no mínimo 6 caracteres entre números e letras.",
    placeholder: "••••••",
    type: CtrlType.PASSWORD,
    required: true,
    requiredMessage: "Campo obrigatório",
    minLength: 6,
    minLengthMessage: "Sua senha deve conter no mínimo 6 caracteres",
    maxLength: 20,
    maxLengthMessage: "Sua senha deve conter no máximo 20 caracteres"
  },
  {
    name: "newPasswordConfirmation",
    label: "Confirmação de senha",
    description: "Obs.: sua senha deve ter no mínimo 6 caracteres entre números e letras.",
    placeholder: "••••••",
    type: CtrlType.PASSWORD,
    required: true,
    requiredMessage: "Campo obrigatório",
    minLength: 6,
    minLengthMessage: "Sua senha deve conter no mínimo 6 caracteres",
    maxLength: 20,
    maxLengthMessage: "Sua senha deve conter no máximo 20 caracteres"
  }
];
